<template>
  <div class="component-content sub-content">

    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column prop="name" label="审批单名称">
      </el-table-column>
      <el-table-column prop="flowSource" label="审批类型编号" width="150">
      </el-table-column>
      <el-table-column prop="flowSourceType" label="审批子类型" width="150">
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="success" plain size="mini" @click="SetApprovalUser(scope.row)">设置审批人员/部门</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <section class="pop-room role-pop approval-set-pop" v-if="setApprovalStatus">
      <a href="javascript:;" @click="setApprovalStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <h3 class="title">设置/修改审批人</h3>

        <!-- 审批人循环组装 -->
        <div class="clear" v-for="approval,a in nowApprovalUsers">
          <div class="tab-title">
            <span class="title">{{approval.name}}</span>
          </div>
          <div class="form-item left mx" v-for="users,j in approval.users">
            <label>{{users}}</label>

            <div class="add-person">
              <el-button v-if="selectArr[getIndex(a,j)] && selectArr[getIndex(a,j)].name" @click="addUser(a,j)"
                type="success" size="mini">{{selectArr[getIndex(a,j)].name}}</el-button>
              <el-button v-else @click="addUser(a,j)" type="info" size="mini">设置固定人员</el-button>
              <el-button @click="addDep(a,j,-1)" :type="selectArr[getIndex(a,j)]=='d:-1'?'success':'info'" size="mini">
                定位当前部门</el-button>
              <el-button @click="addDep(a,j,-2)" :type="selectArr[getIndex(a,j)]=='d:-2'?'success':'info'" size="mini">
                定位当前公司</el-button>
              <el-button @click="addDep(a,j,-3)" :type="selectArr[getIndex(a,j)]=='d:-3'?'success':'info'" size="mini">
                定位到集团</el-button>
            </div>

          </div>
        </div>

      </div>
      <div class="btn-room">
        <el-button @click="submitApprovalSet()" type="primary">确认提交</el-button>
      </div>
    </section>
  </div>
</template>

<script>
  import approvalUsers from '@/Mixins/approvalUsers'
  import {
    mapState
  } from "vuex";
  export default {
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    mixins: [approvalUsers],
    data() {
      return {
        nowApprovalUsers: [],
        setApprovalStatus: false,
        selectArr: [],
        _index: 0,
        row: [],

        ApprovalUsersCount: 0,
        // 列表
        loading: true,
        pageSize: 30,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    mounted() {
      this.getLists()
    },
    components: {},
    methods: {
      submitApprovalSet() {
        let formArr = []
        console.log(this.selectArr)
        for (var i = 0; i < this.selectArr.length; i++) {
          if (this.selectArr[i] && this.selectArr[i].name) {
            formArr.push('p:' + this.selectArr[i].id)
          } else {
            formArr.push(this.selectArr[i])
          }
        }

        // console.log(formArr.join(","))
        ajax.post('/sys/approvalIds/set', {
          flowsSource: this.row.flowSource,
          flowSourceType: this.row.flowSourceType,
          approvalIds: formArr.join(",")
        }, (res) => {
          this.$message.success("设置审批节点成功")
          this.setApprovalStatus = false
        })
      },
      getIndex(a, j) {
        var index = 0;
        for (var i = 0; i < a; i++) {
          index += this.nowApprovalUsers[i].users.length;
        }
        return index + j;
      },
      // 添加审批人
      addUser(a, j) {
        this._index = this.getIndex(a, j)
        this.$store.commit('set_contactSelectArr', [])
        this.$store.commit('set_contactShow', true)
        this.$store.commit('set_contactSingleSelect', true)
      },
      // 添加部门
      addDep(a, j, d) {
        this._index = this.getIndex(a, j)
        this.$set(this.selectArr, this._index, "d:" + d)
      },
      // 获取当前审批人员/部门
      GetApprovalUser(row) {
        ajax.post('/sys/approvalIds/get', {
          flowsSource: row.flowSource,
          flowSourceType: row.flowSourceType,
        }, (res) => {
          if (this.ApprovalUsersCount == res.vo.approvalIds.split(",").length) {
            this.selectArr = res.vo.approvalIds.split(",")
            for (var i = 0; i < this.selectArr.length; i++) {
              let _item = this.selectArr[i]
              if (_item.indexOf('p') != -1) {
                this.selectArr[i] = res.vo.approvals[i].user
              }
            }
          }
        }, () => {})
      },
      // 设置审批人员/部门
      SetApprovalUser(row) {
        this.row = row
        let _key = "c" + row.flowSource
        if (row.flowSourceType) {
          _key += "_" + row.flowSourceType
        }
        this.nowApprovalUsers = this.approvalUsers[_key]

        console.log(this.nowApprovalUsers)
        this.ApprovalUsersCount = 0
        for (var i = 0; i < this.nowApprovalUsers.length; i++) {
          this.ApprovalUsersCount += this.nowApprovalUsers[i].users.length
        }
        this.selectArr = new Array(this.ApprovalUsersCount).fill("d:-2")

        this.setApprovalStatus = true
        this.GetApprovalUser(row)
      },

      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      getLists() {
        ajax.get('/sys/flows', '', (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      "contactSelectArr"() {
        if (this.contactSelectArr.length > 0) {
          console.log(this.contactSelectArr)
          this.$set(this.selectArr, this._index, this.contactSelectArr[0])
          this.$store.commit('set_contactSelectArr', [])
        }
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/set/approvalSet.vue